import { ArrowPathIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { formatDistanceToNow } from "date-fns";
import { de } from "date-fns/locale";
import type { FunctionComponent } from "react";

import Button from "~/components/buttons/Button/Button";
import type { ButtonVariantsProps } from "~/components/buttons/Button/buttonVariants.ts";

type Props = {
	buttonSize?: ButtonVariantsProps["size"];
	generatedAt: string;
	isRefreshing: boolean;
	onRefresh: () => void;
};

const UtilisationReportRefreshControl: FunctionComponent<Props> = ({ buttonSize, generatedAt, isRefreshing, onRefresh }) => {
	const age = formatDistanceToNow(new Date(generatedAt), { addSuffix: true, locale: de });

	return <div className="flex items-center justify-end gap-x-3">
		<span className="text-xs text-gray-500">Zuletzt aktualisiert: {age}</span>
		<Button theme="secondary"
				size={buttonSize}
				onClick={onRefresh}
				disabled={isRefreshing}>
			<ArrowPathIcon className={clsx("size-4", isRefreshing && "animate-spin")} />
			Aktualisieren
		</Button>
	</div>;
};

export default UtilisationReportRefreshControl;
